import { formatMstLabel } from "../utilities";

// Per-surface filter configs for <FilterPanel>. Master models are referenced by
// STRING name (e.g. 'mst-location') — this fixes a latent bug where the old modals
// passed MST_MODEL_NAMES[index] and several were off-by-one (location->dosha,
// motherTongue->qualification, professionSector->user-type, designation->father-details,
// familyType->findmatchfor, dietType->familytype), so those dropdowns searched the
// wrong collection. String names are correct by construction.

const cityLabel = (e) => (e.city ? e.city.split(",")[0] : "N/A");

export const BG_PROFILE_FILTERS = [
  {
    key: "gender",
    label: "Gender",
    type: "reactSelect",
    options: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
    ],
    placeholder: "Any",
  },
  { key: "birthLocation", label: "Birth Location", type: "asyncSelect", model: "mst-location", masterDataKey: "mst-location", optionLabel: cityLabel, placeholder: "Select location" },
  { key: "residentLocation", label: "Resident Location", type: "asyncSelect", model: "mst-location", masterDataKey: "mst-location", optionLabel: cityLabel, placeholder: "Select location" },
  { key: "religiousBelief", label: "Religious Belief", type: "asyncSelect", model: "mst-regiousbelief", masterDataKey: "mst-regiousbelief", optionLabel: "belief", placeholder: "Select belief" },
  { key: "motherTongue", label: "Mother Tongue", type: "asyncSelect", model: "mst-language", masterDataKey: "mst-language", optionLabel: "language", placeholder: "Select language" },
  { key: "qualification", label: "Qualification", type: "asyncSelect", model: "mst-qualification", masterDataKey: "mst-qualification", optionLabel: "qualification", placeholder: "Select qualification" },
  { key: "professionSector", label: "Profession Sector", type: "asyncSelect", model: "mst-profession-sector", masterDataKey: "mst-profession-sector", optionLabel: "professionSector", placeholder: "Select sector" },
  { key: "professionalDesignation", label: "Designation", type: "asyncSelect", model: "mst-designation", masterDataKey: "mst-designation", optionLabel: "designation", placeholder: "Select designation" },
  { key: "annualIncome", label: "Annual Income", type: "asyncSelect", model: "mst-annual-income", masterDataKey: "mst-annual-income", optionLabel: "annual Income In(₹)", placeholder: "Select income" },
  { key: "familyType", label: "Family Type", type: "asyncSelect", model: "mst-familytype", masterDataKey: "mst-familytype", optionLabel: (e) => formatMstLabel(e.familyType), placeholder: "Select type" },
  { key: "dietType", label: "Diet Type", type: "asyncSelect", model: "mst-diettype", masterDataKey: "mst-diettype", optionLabel: (e) => formatMstLabel(e.dietType), placeholder: "Select diet" },
  {
    key: "maritalStatus",
    label: "Marital Status",
    type: "select",
    options: [
      { value: "NEVER_MARRIED", label: "Never Married" },
      { value: "PREVIOUSLY_MARRIED", label: "Previously Married" },
      { value: "WIDOWED", label: "Widowed" },
      { value: "AWAITING_DIVORCE", label: "Awaiting Divorce" },
    ],
  },
  {
    key: "ownerRelationship",
    label: "Profile For",
    type: "select",
    options: [
      { value: "Myself", label: "Myself" },
      { value: "Son", label: "Son" },
      { value: "Daughter", label: "Daughter" },
      { value: "Brother", label: "Brother" },
      { value: "Sister", label: "Sister" },
      { value: "Relative", label: "Relative" },
      { value: "Friend", label: "Friend" },
    ],
  },
  { label: "Created", type: "dateRange", startKey: "startDate", endKey: "endDate" },
];

export const MATCH_SEEKER_FILTERS = [
  { key: "fullName", label: "Name", type: "text", placeholder: "Full name" },
  { key: "emailId", label: "Email", type: "text", placeholder: "Email address" },
  { key: "mobile", label: "Mobile", type: "text", placeholder: "Mobile number" },
  { key: "religion", label: "Religion", type: "asyncSelect", model: "mst-religion", masterDataKey: "mst-religion", optionLabel: "religion", placeholder: "Select religion", resetOnChange: ["caste", "subCaste"] },
  { key: "caste", label: "Caste", type: "asyncSelect", model: "mst-caste", masterDataKey: "mst-caste", optionLabel: "caste", placeholder: "Select caste", religionIdFrom: "religion", disabledWhenEmpty: "religion", resetOnChange: ["subCaste"] },
  { key: "subCaste", label: "Sub Caste", type: "text", placeholder: "Sub caste" },
  {
    key: "_accountStatus",
    label: "Account Status",
    type: "reactSelect",
    placeholder: "Select status",
    options: [
      { value: "ACTIVE", label: "Active" },
      { value: "BLOCKED", label: "Blocked" },
      { value: "INACTIVE", label: "Inactive" },
    ],
  },
  {
    key: "subscription",
    label: "Subscription",
    type: "select",
    options: [
      { value: "ACTIVE", label: "Active" },
      { value: "INACTIVE", label: "Inactive" },
    ],
  },
  {
    key: "invited_by",
    label: "Invited",
    type: "select",
    options: [
      { value: "INVITED", label: "Invited" },
      { value: "NOT_INVITED", label: "Not Invited" },
    ],
  },
  { label: "Created", type: "dateRange", startKey: "startDate", endKey: "endDate" },
  { key: "updatedAt", label: "Updated At", type: "date" },
];

export const BOOST_FILTERS = [
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "pending_payment", label: "Pending Payment" },
      { value: "processing", label: "Processing" },
      { value: "active", label: "Active" },
      { value: "expired", label: "Expired" },
      { value: "cancelled", label: "Cancelled" },
    ],
  },
  {
    key: "scopeType",
    label: "Scope",
    type: "select",
    options: [
      { value: "specific_states", label: "Specific States" },
      { value: "all_india", label: "All India" },
      { value: "nri_specific", label: "NRI Specific" },
      { value: "nri_all", label: "NRI All" },
    ],
  },
  {
    key: "paymentStatus",
    label: "Payment",
    type: "select",
    options: [
      { value: "pending", label: "Pending" },
      { value: "paid", label: "Paid" },
      { value: "failed", label: "Failed" },
    ],
  },
  { key: "amountMin", label: "Min Amount (₹)", type: "number", placeholder: "0" },
  { key: "amountMax", label: "Max Amount (₹)", type: "number", placeholder: "Any" },
  { label: "Created", type: "dateRange", startKey: "startDate", endKey: "endDate" },
];

export const STATUS_REPORT_FILTERS = [
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "pending", label: "Pending" },
      { value: "dismissed", label: "Dismissed" },
      { value: "cleared", label: "Cleared" },
    ],
  },
  {
    key: "reason",
    label: "Reason",
    type: "select",
    options: [
      { value: "inappropriate", label: "Inappropriate" },
      { value: "spam", label: "Spam" },
      { value: "fake_profile", label: "Fake profile" },
      { value: "harassment", label: "Harassment" },
      { value: "other", label: "Other" },
    ],
  },
  { label: "Reported", type: "dateRange", startKey: "startDate", endKey: "endDate" },
];

export const INFLUENCER_FILTERS = [
  { key: "search", label: "Search", type: "text", placeholder: "Code or handle…" },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
      { value: "pending", label: "Pending payout" },
    ],
  },
];

export const BROADCAST_FILTERS = [
  { key: "title", label: "Title", type: "text", placeholder: "Search title…" },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "draft", label: "Draft" },
      { value: "scheduled", label: "Scheduled" },
      { value: "sent", label: "Sent" },
      { value: "failed", label: "Failed" },
      { value: "cancelled", label: "Cancelled" },
    ],
  },
  {
    key: "segment",
    label: "Segment",
    type: "select",
    options: [
      { value: "ALL", label: "All Users" },
      { value: "FREE", label: "Free" },
      { value: "FREE_OLD", label: "Free 7d+" },
      { value: "SPARK_BUNDLE", label: "Spark Bundle" },
      { value: "PREMIUM", label: "Premium" },
      { value: "ELITE", label: "Elite" },
      { value: "ANNUAL", label: "Annual" },
      { value: "PAID", label: "All Paid" },
      { value: "INACTIVE_30D", label: "Inactive 30d" },
      { value: "NO_ALIGNMENT", label: "No Alignment" },
      { value: "EXPIRING_7D", label: "Expiring 7d" },
    ],
  },
  { label: "Created", type: "dateRange", startKey: "startDate", endKey: "endDate" },
];

export const USER_PACK_FILTERS = [
  { key: "search", label: "Search", type: "text", placeholder: "Name / email / phone…" },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "active", label: "Active" },
      { value: "expired", label: "Expired" },
      { value: "free", label: "Free" },
    ],
  },
  {
    key: "packType",
    label: "Pack Type",
    type: "select",
    options: [
      { value: "free", label: "free" },
      { value: "single_unlock", label: "single_unlock" },
      { value: "spark_bundle", label: "spark_bundle" },
      { value: "premium", label: "premium" },
      { value: "elite", label: "elite" },
      { value: "annual", label: "annual" },
    ],
  },
];

// Normalize a FilterPanel filters object into a flat payload for a filter endpoint:
// react-select / async-select values are { value, label } -> take .value; strings as-is;
// arrays (multiSelect) -> array of .value; empties dropped. `remap` renames keys if a
// surface's filter key differs from the server field name.
export const buildFlatPayload = (filters = {}, remap = {}) => {
  const out = {};
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === "") continue;
    let nv;
    if (Array.isArray(v)) nv = v.map((o) => (o && typeof o === "object" ? o.value : o)).filter(Boolean);
    else if (v && typeof v === "object") nv = v.value;
    else nv = v;
    if (nv === undefined || nv === null || nv === "" || (Array.isArray(nv) && !nv.length)) continue;
    out[remap[k] || k] = nv;
  }
  return out;
};
